<header>
  <div id="cover_page" class="header-preview d-flex justify-content-between">
    <img [src]="event?.cover_page || 'https://library.micetribe.com/images/default-banner.jpg'" alt="" />
    <!-- <img class="img-cover" [src]="event?.cover_page || 'https://library.micetribe.com/icons/default_cover.svg'" alt=""> -->
    <ngx-landing-share *ngIf="isLandingPage" [formSlug]="persona.slug" [eventSlug]="event.slug"></ngx-landing-share>
    <ngx-event-times class="timing" *ngIf="!isLandingPage && !isInvitation" [startDate]="event.public_start_date" [endDate]="event.public_end_date"></ngx-event-times>
  </div>
  <div id="header-info" class="header-info d-flex" [ngClass]="{ 'align-items-center': isLandingPage, 'align-items-end': isInvitation }">
    <div class="header-description d-flex justify-content-between w-100" [ngClass]="{ 'flex-column': isInvitation }">
      <h2 [title]="event.name" [ngClass]="{ 'mt-4': !isLandingPage, 'mb-0': isInvitation && socials.length > 0 }">{{ event.name }}</h2>
      <div class="timer-links-container">
        <ngx-landing-timer
          *ngIf="!isInvitation"
          [isLandingPage]="isLandingPage"
          [startDate]="event.public_start_date"
          [endDate]="event.public_end_date"
          [eventTimezone]="event.timezone"
        ></ngx-landing-timer>
        <div class="links" *ngIf="(socials.length && isLandingPage) || isInvitation">
          <ul class="d-flex" [ngStyle]="{ margin: isInvitation ? '0' : 'initial' }">
            <ng-container *ngFor="let social of socials">
              <li>
                <a [href]="social.url" target="_blank" rel="noopener noreferrer" class="d-inline-block tw-w-[27px] tw-h-[27px]">
                  <img
                    *ngIf="isKnownSocialMediaUrl(social.url); else unknownSocialIcon"
                    [src]="social.icon"
                    [alt]="social.title"
                    class="w-100 h-100"
                    [title]="social.title"
                  />
                  <ng-template #unknownSocialIcon>
                    <svg
                      class="w-100 h-100"
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M14 0C11.2311 0 8.52431 0.821086 6.22202 2.35942C3.91973 3.89776 2.12532 6.08426 1.06569 8.64243C0.00606598 11.2006 -0.271181 14.0155 0.269012 16.7313C0.809205 19.447 2.14258 21.9416 4.10051 23.8995C6.05845 25.8574 8.55301 27.1908 11.2687 27.731C13.9845 28.2712 16.7994 27.9939 19.3576 26.9343C21.9157 25.8747 24.1022 24.0803 25.6406 21.778C27.1789 19.4757 28 16.7689 28 14C28 12.1615 27.6379 10.341 26.9343 8.64243C26.2307 6.94387 25.1995 5.40052 23.8995 4.1005C22.5995 2.80048 21.0561 1.76925 19.3576 1.06569C17.659 0.362121 15.8385 0 14 0ZM11.6046 24.9102C10.0778 24.5614 8.64119 23.8959 7.38791 22.9566C6.13462 22.0174 5.09257 20.8254 4.32921 19.4579C3.56586 18.0903 3.09822 16.5777 2.95659 15.0179C2.81495 13.4582 3.00247 11.8861 3.50701 10.4034L3.85981 10.4314C4.60615 10.7874 5.26676 11.3005 5.79642 11.9355C6.32608 12.5705 6.71229 13.3125 6.9286 14.1106C7.16128 15.0324 7.60828 15.8863 8.23326 16.6027C8.85823 17.3192 9.64351 17.8779 10.5252 18.2336C12.2164 19.0134 12.5706 21.2002 11.6046 24.9102ZM16.9106 11.9C16.9105 11.7882 16.8968 11.6768 16.87 11.5682C16.6166 10.4204 16.1143 9.34224 15.3985 8.40991C14.6827 7.47758 13.7708 6.71382 12.7274 6.1726C11.5024 5.3956 10.7422 4.9126 10.5378 3.3852C12.7175 2.65082 15.0705 2.60628 17.2764 3.25765C19.4823 3.90901 21.4337 5.22461 22.8648 7.0252C20.8208 7.3318 19.7106 10.3222 19.7106 11.8986C19.5611 12.1298 19.3524 12.3166 19.1062 12.4397C18.8599 12.5628 18.5852 12.6177 18.3106 12.5986C18.0361 12.6178 17.7615 12.5632 17.5153 12.4403C17.2691 12.3175 17.0603 12.1309 16.9106 11.9ZM19.3074 23.7622L18.3176 20.7956C18.3654 20.1216 18.6553 19.4876 19.1339 19.0105C19.6125 18.5335 20.2474 18.2456 20.9216 18.2L23.9162 19.1114C22.8811 21.0888 21.2753 22.7092 19.3074 23.7622Z"
                        fill="#6B7280"
                      />
                    </svg>
                  </ng-template>
                </a>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
  </div>
</header>
